/**
 * useDeviceInfo — conecta al agente Go v3.0 en puerto 9876
 * El agente Go expone los mismos endpoints que el PS1 para compatibilidad.
 * 
 * En producción UNEATLANTICO, el agente Go se instala como servicio Windows:
 *   helpdesk-agent.exe -server http://helpdesk.uneatlantico.local:3000 -install
 */
import { useState, useEffect } from 'react';

const AGENT_URL = 'http://localhost:9876';

export function useDeviceInfo() {
  const [info,   setInfo]   = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 2000);

    fetch(`${AGENT_URL}/info`, { signal: controller.signal })
      .then(r => r.json())
      .then(data => {
        clearTimeout(timer);
        if (data.ok) { setInfo(data); setStatus('agent'); }
        else          { setStatus('browser'); }
      })
      .catch(() => setStatus('browser'));

    return () => { clearTimeout(timer); controller.abort(); };
  }, []);

  return { info, status };
}

export async function fetchAgentData(endpoint) {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    const res = await fetch(`${AGENT_URL}/${endpoint}`, { signal: controller.signal });
    clearTimeout(timer);
    return await res.json();
  } catch {
    return { ok: false, error: 'Agente no disponible' };
  }
}
